import { Component, OnInit } from '@angular/core';
import { PaymentStatementDetailsSearchHandler } from './payment-statement-details-search.handler';
import { ActivatedRoute, Router } from '@angular/router';
import { HeaderService } from 'src/app/system-common/services/header.service';
import { SettingService } from 'src/app/system-common/services/setting.service';
import { FinanceService } from '../services/finance.service';

@Component({
  selector: 'sym-payment-statement-details-search',
  templateUrl: './payment-statement-details-search.component.html',
  styleUrls: ['./payment-statement-details-search.component.scss'],
})
export class PaymentStatementDetailsSearchComponent
  extends PaymentStatementDetailsSearchHandler
  implements OnInit
{
  constructor(
    public service: FinanceService,
    public headerService: HeaderService,
    public router: Router,
    public settingService: SettingService,
    public route: ActivatedRoute
  ) {
    super(service, headerService, router, settingService, route);
  }

  ngOnInit() {
    super.ngOnInit();
  }
}
